import ApiConnector from '@/models/ApiConnector';
import ServiceModel from '@models/ServiceModel';

const service = window.APP_CONFIG.services.find(service => service.id === 'fondations');

export const fondationsConnector = new ApiConnector({ baseURL: service?.configurations.api_endpoint });

export default class FondationsServiceModel extends ServiceModel {
	public static get connector() {
		return fondationsConnector;
	}

	public static serviceName = 'fondations';
	public static partitionName = 'jts';
}
